import ApolloClient, { createNetworkInterface } from 'apollo-client'
import VueApollo from 'vue-apollo'
import Vue from 'vue'

const networkInterface = createNetworkInterface({
  uri: `/api/queries`,
  transportBatching: true,
})

const apolloClient = new ApolloClient({
  networkInterface,
  dataIdFromObject: (result) => {
    if (result.id && result.__typename) {
      return result.__typename + result.id
    }
    return null // Make sure to return null if this object doesn't have an ID
  },
})

export const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
})

Vue.use(VueApollo)



// WEBPACK FOOTER //
// ./src/setup/apollo.js